import { TextField } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import type { Tenant } from '../../core/types/data-models';
import { formatDate } from '../../shared/utils/format';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 220 },
  { field: 'createdAt', headerName: 'Created', width: 180, valueFormatter: (v) => formatDate(v as string) },
];

export function TenantsPage() {
  return (
    <CrudPage<Tenant>
      title="Customers"
      description="Tenants in the system. Each tenant gets its own data, lines of business, and report templates."
      cacheKey={['tenants']}
      service={resources.tenants}
      columns={columns}
      defaultValues={{ name: '' }}
      renderForm={({ values, setValues }) => (
        <TextField
          label="Name"
          required
          value={values.name ?? ''}
          onChange={(e) => setValues({ ...values, name: e.target.value })}
          fullWidth
        />
      )}
    />
  );
}
